import { render, staticRenderFns } from "./MtAuditLog.vue?vue&type=template&id=3a63aa06&scoped=true&"
import script from "./MtAuditLog.vue?vue&type=script&lang=js&"
export * from "./MtAuditLog.vue?vue&type=script&lang=js&"
import style0 from "./MtAuditLog.vue?vue&type=style&index=0&id=3a63aa06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a63aa06",
  null
  
)

export default component.exports